import styled from 'styled-components';

export const ContentContainer = styled.div`
  width: 100%;
  padding: 20px;
  margin-top: 20px;
  box-sizing: border-box;
  min-height: 408px;
`;

export const AgreementWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 20px;
`;

export const AgreementLabel = styled.p`
  & span {
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
  }
  margin: 0;
`;

export const TnCFrameWrapper = styled.div`
  border: 1px solid #ededed;
  border-radius: 4px;
`;

export const TnCFrame = styled.div`
  border: none;
  border-radius: 4px;
  width: 100%;
  height: 408px;
  overflow-y: scroll;
  padding: 16px;
  > ol {
    padding-inline-start: 16px;
    margin-bottom: 0px;
  }
  > h1.title {
    font-size: 14px;
    font-weight: 700;
  }
  > div.sensor {
    height: 1px;
    width: 100%;
  }
`;
